export default [
  require('./works/friendformant'),
  require('./works/fatatom'),
  require('./works/iheartcolors'),
  require('./works/spotifyroadtrip'),
  require('./works/chromemidnight'),
  require('./works/runescape'),
  require('./works/runescaperedux'),
  require('./works/crypto'),
  require('./works/playmidnight'),
  require('./works/debtrainbow'),
  require('./works/dailynook'),
  require('./works/scummypoker'),
].reverse();



// WEBPACK FOOTER //
// ./src/data/works.js